export default (theme) => ({
  tableWrapper: {
    margin: "0px 10px",
    overflow: "auto",
    /* "max-height": 400, */
    padding: "15px 15px 15px 0px",
  },
  actionIcons: {
    padding: 8,
    boxShadow: "none",
    "&&:hover": {
      backgroundColor: "transparent",
    },
  },
});
